import React from 'react'

function RectangularQBR() {
    return (
        <embed src="\pdfs\E2.5.2.3_Q-BR-Rectangular_floor_displacement_outlet_12.2010_kr.pdf" width="100%" height="2100px" />
    )
}

export default RectangularQBR